import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Pill from '../../Pill/Pill.js';
import { CONTEXT_MENU_CATEGORY_KEY, CONTEXT_MENU_COMPONENT_KEY } from '../ContextMenu.meta.js';
import { IContextMenuPillProps } from '../models/IContextMenuPillProps.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ContextMenuPill = (props: IContextMenuPillProps) => {
	return <Pill {...props} />;
};

export default InjectedStyledComponent(ContextMenuPill, CONTEXT_MENU_CATEGORY_KEY, CONTEXT_MENU_COMPONENT_KEY, [
	'contextMenuPill',
]);
